import { truckerProfileApiService } from 'config/service';
import { ITruckerProfileProps } from 'interfaces/profile.interface';
import { urls } from 'constants/urls';

export const getTruckerByPhoneOrDocument = async (personalData: string): Promise<ITruckerProfileProps> => {
  const res = await truckerProfileApiService.get<ITruckerProfileProps>(`${urls.trucker.searchTrucker}`, {
    withCredentials: false,
    params: {
      query: personalData,
    },
  });
  return res as unknown as Promise<ITruckerProfileProps>;
};
